import { AppLayoutProps } from '@amzn/awsui-components-react/polaris/app-layout';
import { useRecoilState } from 'recoil';
import { atom } from 'recoil';

export const key = 'contentTypeState';
export const initialState = 'default';

export const state = atom<AppLayoutProps.ContentType | undefined>({
    key,
    default: initialState,
});

export const useRecoilContentTypeState = () => useRecoilState(state);
